import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-iv',
  templateUrl: './step-section-iv.component.html',
})
export class StepSectionIVComponent {
  constructor(public mdcService: MdcService) { }
}
